/* CostCenterCategories.tsx
	Une page affichant la gestion des catégories de centres de coûts
	Utilise le composant CostCenterCategoriesCrudCard pour lister, ajouter, éditer et supprimer les éléments
*/

// Import React
import React from 'react';

// Import FontAwesome
import { faCubes } from '@fortawesome/free-solid-svg-icons';

// Import Layout
import PageHeader from 'layout/PageHeader';

// Import Feature
import { CostCenterCategoriesCrudCard } from 'features/costCenterCategories';

// Page CostCenterCategories
export const CostCenterCategories: React.FC = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		<PageHeader
			icon={faCubes}
			title="Catégories de centres de coûts"
			subtitle="Gérez les catégories de centres de coûts"
		/>
		<CostCenterCategoriesCrudCard
			size="lg"
			returnPath="/app/settings/depenses"
			className="mt-6"
		/>
	</div>
);
